module.exports = __webpack_public_path__ + "panel_solar.png?f1345379b371c91419763021601d1b74";


//////////////////
// WEBPACK FOOTER
// ./images/img/panel_solar.png
// module id = 935
// module chunks = 0